import { baseApi } from "@/base"
import type { Feature } from "@/feature/model"

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    featureEnabled: build.query<boolean, Feature>({
      query: (id) => `features/${id}`,
    }),
  }),
})

export const { useFeatureEnabledQuery } = api
